import {BrandID} from "../enums/brand-id";
import {SelectionItem} from "../selections/selection-item";

export class LeadTimeUtils {

  private static readonly WARRANTY_PARTS_LEAD_TIME_CODES: string[] = ['RSP', 'CSP', 'RPW', 'CPW'];

  private static readonly STOCK_PROGRAM_LEAD_TIME_CODES: string[] = ['STKC', 'STKR', 'HTBC', 'HTBR'];


  private static readonly QUICK_SHIP_LEAD_TIME_CODES: string[] = ['SST', 'SS5', 'QSC2', 'QSC3', 'QSR2', 'QSR3', ...LeadTimeUtils.STOCK_PROGRAM_LEAD_TIME_CODES];

  public static readonly QUICK_SHIP_FPA_MESSAGE: string = 'FPA is not allowed on quotes or orders with an expedited lead time selected (Quick Build, Quick Stock, Quick Deal or Short Ship).  Please change the lead time to Standard before requesting a FPA';

  private static readonly VALID_LEAD_TIME_CODES = {
    [BrandID.CLM]: ['CPW', 'RPW']
  } as const;

  public static validWarrantyLeadTime(leadTimeCode: string, brandID: BrandID): boolean {
    const validCodes = LeadTimeUtils.VALID_LEAD_TIME_CODES[brandID as keyof typeof LeadTimeUtils.VALID_LEAD_TIME_CODES];
    return validCodes ? (validCodes as readonly string[]).includes(leadTimeCode) : false;
  }

  public static isPartsOrWarrantyLeadTime(leadTimeCode: string): boolean{
    return LeadTimeUtils.WARRANTY_PARTS_LEAD_TIME_CODES.includes(leadTimeCode);
  }

  public static isQuickShip(leadTimeCode: string | undefined): boolean {
    return LeadTimeUtils.QUICK_SHIP_LEAD_TIME_CODES.includes(leadTimeCode ?? '');
  }

  public static isStockProgram(leadTimeCode: string | undefined): boolean {
    return LeadTimeUtils.STOCK_PROGRAM_LEAD_TIME_CODES.includes(leadTimeCode ?? '');
  }

  public static selectableLeadTimes(leadTimes: SelectionItem[], currentLeadTimeCode: string | undefined): SelectionItem[] {
    return leadTimes.filter((leadTime) => !LeadTimeUtils.isStockProgram(leadTime.code) || leadTime.code === currentLeadTimeCode);
  }

}
